import {Component, OnInit} from '@angular/core';
import {AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators} from '@angular/forms';
import {DialogRef} from "@angular/cdk/dialog";
import {UserService} from "../../services/user.service";
import {DataService} from "../../services/data.service";

@Component({
  selector: 'app-edit-own-password',
  templateUrl: './edit-own-password.component.html',
  styleUrls: ['./edit-own-password.component.scss'],
})
export class EditOwnPasswordComponent implements OnInit {
  public editForm: UntypedFormGroup;
  public formSubmitted: boolean;

  public constructor(
    private dialogRef: DialogRef<null>,
    private shareService: UserService,
    private fb: UntypedFormBuilder,
    private dataService: DataService,
  ) {
  }

  ngOnInit(): void {
    this.formSubmitted = false;
    this.editForm = this.fb.group({
      currentPassword: this.fb.control(
        {value: '', disabled: false},
        Validators.compose([
          Validators.required,
          this.validatorUserPassword,
          Validators.minLength(8),
          Validators.maxLength(255),
        ])
      ),
      newPassword: this.fb.control(
        {value: '', disabled: false},
        Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(255)])
      ),
      newPasswordRepeat: this.fb.control(
        {value: '', disabled: false},
        Validators.compose([Validators.required, this.validatorSamePasswords, Validators.maxLength(255)])
      ),
    });
  }

  public close(): void {
    this.dialogRef.close();
  }

  public currentPasswordInvalid(): boolean {
    const control = this.editForm.get('currentPassword');
    return this.formSubmitted && control.invalid;
  }

  public newPasswordInvalid(): boolean {
    const control = this.editForm.get('newPassword');
    return this.formSubmitted && control.invalid;
  }

  public async submit() {
    this.formSubmitted = true;

    if (this.editForm.invalid) {
      return;
    }

    const installationUser = this.shareService.user;
    if (this.editForm.get('newPassword').value === this.editForm.get('newPasswordRepeat').value) {
      installationUser.password = this.editForm.get('newPassword').value;

      const user = await this.dataService.getUser(installationUser._id)
      user.password = installationUser.password;
      await this.dataService.updateUser(user);

      this.shareService.setUser(installationUser);

      this.close();
    }
  }

  private validatorSamePasswords: ValidatorFn = (control: AbstractControl) => {
    if (this.editForm && control.value) {
      const passwordCtrl = this.editForm.get('newPassword');
      if (passwordCtrl) {
        const a = control.value ? control.value.trim() : null;
        const b = passwordCtrl.value ? passwordCtrl.value.trim() : null;
        if (a !== b) {
          return {passwordsdiffers: true};
        }
      }
    }
    return null;
  };

  private validatorUserPassword: ValidatorFn = (control: AbstractControl) => {
    if (this.editForm && control.value) {
      const passwordCtrl = this.shareService.user.password;
      if (passwordCtrl) {
        const a = control.value ? control.value.trim() : null;
        const b = passwordCtrl ? passwordCtrl.trim() : null;
        if (a !== b) {
          return {'current.password.invalid': true};
        }
      }
    }
    return null;
  };
}
